import { combineReducers } from "redux";

import user from "./user";
import regions from "./regions";
import onBoardingInfo from "./onBoardingInfo";
import terminalReducer from "./terminalReducer";
import transactionsReducer from "./transactionsReducer";
import agentAccountReducer from "./agentAccountReducer";
import asynReducer from "../../asyncLoading/AsyncReducer";
import dashboard from "./dashboard/terminalDashboardReducer";
import onboardingReducer from "./dashboard/onboardingDashboardReducer";
import terminalDashboardReducer from "./dashboard/terminalDashboardReducer";

const rootreducer = combineReducers({
  user,
  regions,
  dashboard,
  asynReducer,
  terminalReducer,
  onBoardingInfo,
  agentAccountReducer,
  onboardingReducer,
  terminalDashboardReducer,
  transactionsReducer,
});

export default rootreducer;
